<template lang="pug">
  .privacy-policy
    CusRadio(:value="agreePrivacy" @input="handleChange")
    span.normal 已阅读并同意
    span.canClick(@click="goMember") 《哈啰会员服务协议》
    span.normal 与
    span.canClick(@click="goRenewal")  《自动续费协议》
</template>

<script>
import { commonGoLink } from '@/utils';
import CusRadio from './cus-radio';
import { PROTOCOL_URL } from '../common/const';

export default {
  components: {
    CusRadio,
  },
  model: {
    prop: 'agreePrivacy',
    event: 'change',
  },
  props: {
    agreePrivacy: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    handleChange(value) {
      this.$emit('change', value);
    },
    goMember() {
      commonGoLink(PROTOCOL_URL.MEMBER, { isRuleLink: true });
    },
    goRenewal() {
      commonGoLink(PROTOCOL_URL.RENEWAL, { isRuleLink: true });
    },
  },
};
</script>

<style lang="less" scoped>
  .privacy-policy {
    font-size: 0.11rem;
    color: #879099;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 0.1rem;
  }
</style>
